import { useTenantCapabilities } from './feature';

/** Settings > Manage Users > Approvals (ApprovalsPage; "My requests" for internal admins). */
export const APPROVALS_PATH = '/settings/approvals';

export type ApprovalsLinkTitle = 'Approvals' | 'My requests';

/**
 * The Approvals entry of the settings menu, from the identity service's capabilities of the
 * active role: "Approvals" with `approve` (a Super Admin, or an organisation admin for their
 * organisation), "My requests" with `my_requests` only (an internal admin who prepares
 * requests and never approves; owner 2026-10-16); null otherwise.
 * `active`: the settings menu is shown (no call while it is closed).
 */
export function useApprovalsLink(active: boolean): ApprovalsLinkTitle | null {
  const caps = useTenantCapabilities(active);
  if (caps?.approve) return 'Approvals';
  if (caps?.my_requests) return 'My requests';
  return null;
}
